import { CsI18n } from "../../shared/csI18n/csI18n";
import { CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import { Card, FormLayout, Layout, TextField } from "@shopify/polaris";
import HeadingHelper from "../../helpers/HeadingHelper";
import React from "react";
import ChoiceListWithChildren from "../ChoiceListWithChildren";

const PrivacyCollectInfo = (props) => {
  const {
    validatorClass,
    informationYouCollect, concernEmail,
    handleChange, handleChoiceListChange, handleChangeTextFieldOfChoice,
  } = props;
  
  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("privacy.annotate.title.privacy")}
      description={CsI18n.t('privacy.annotate.desc.privacy')}>
      <CsValidationForm name={validatorClass} realtime={true}>
        <Card title="">
          <Card.Section>
            <FormLayout>
              <FormLayout.Group>
                <ChoiceListWithChildren
                  title={HeadingHelper.h3tt('Information you collect', 'privacy.explain.collect_info')}
                  choices={informationYouCollect}
                  masterListKey={'informationYouCollect'}
                  subListKeys={[]}
                  handleChoiceListChange={handleChoiceListChange}
                  handleChangeTextFieldOfChoice={handleChangeTextFieldOfChoice}
                />
                <V>
                  <TextField
                    label={HeadingHelper.h3tt('Email for concerns about personal data', 'privacy.explain.concern_email')}
                    value={concernEmail} onChange={handleChange('concernEmail')} />
                  <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                  <V.Item rule="email" title={CsI18n.t("Not a valid email.")} />
                </V>
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
        </Card>
      </CsValidationForm>
    </Layout.AnnotatedSection>
  )
}

export default PrivacyCollectInfo;